export const notNullish = <T>(val: T) => val !== null && val !== undefined;
